import React, { useCallback, useRef } from "react";
import {
  Grid,
  CardHeader,
  CardContent,
  Box,
  TextField,
  CircularProgress,
  Avatar,
  Button,
  Select,
  MenuItem,
  FormHelperText,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { Loader } from "../../components/CustomLoader";
import { bannerServices } from "../../services/bannerService";
import errorHandler from "../../utils/errorHandler";
import { capitalize } from "../../utils/helpers";
import { IMAGE_BASE } from "../../utils/constants";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import CardLayout from "../../layouts/CardLayout";
import moment from "moment";
import tournamentsService from "../../services/tournaments";

const ViewBanner = () => {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [tournaments, setTournaments] = useState([]);
  const [tournamentname, setTournamanename] = useState("");
  const [ImagePreview,setImagePreview] = useState("")

  const [loading, setLoading] = useState(true);

  const userData = async () => {
    try {
      setLoading(true);
      const [bannerRes, tournamentsRes] = await Promise.all([
        bannerServices.getById({ id }),
        tournamentsService.getAll(),
      ]);
      setData(bannerRes.data.data);
      setTournaments(tournamentsRes.data.data || []);
    } catch (error) {
      errorHandler(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    userData();
  }, []);
  useEffect(() => {
    if (data && tournaments.length > 0) {
      getTournamentnamefromid(data.tournament_id);
    }
  }, [data, tournaments]);



  const getTournamentnamefromid = (tid) => {
    if (!tid) {
      return;
    }
    const name = tournaments.find((t) => t.id === tid);
    setTournamanename(name.name);
  };

    useEffect(() => {
  const loadImage = async () => {
    try {
      const response = await fetch(`${IMAGE_BASE}${data?.image_url}`);
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      setImagePreview(url);
    } catch (err) {
      console.error("Failed to load image", err);
    }
  };

  if (data?.image_url) {
    loadImage();
  }
}, [data]);
  


  return (


    <div>
      <>
        <Box >
          
          <Helmet>
            <title>Banner Details</title>
          </Helmet>
          <CardLayout>
            
            <CardHeader title="Banner Details" />
            {loading ? (
            <>
              <CircularProgress
                style={{
                  display: "block",
                  margin: "auto auto",
                  cursor: "pointer",
                  // backgroundColor: "red",
                }}
                size={24}
              />
            </>
          ):<CardContent >
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Typography align="center" variant="subtitle2" mb={2}>
                    Banner Image
                  </Typography>

                  <Avatar
                    style={{
                      display: "block",
                      margin: "0 auto",
                      cursor: "pointer",
                    }}
                    src={ImagePreview}
                    alt="Banner Image"
                    className="avatar"
                  />
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="name"
                    required
                    name="name"
                    value={data?.name}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="tournament"
                    required
                    name="tournament"
                    value={tournamentname}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    // type="date"
                    label="start Date"
                    name="start date"
                    value={moment(data?.start_date).format("YYYY-MM-DD")}
                  />
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    // type="date"
                    label="end Date"
                    name="end date"
                    value={moment(data?.end_date).format("YYYY-MM-DD")}
                  />
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="description"
                    name="description"
                    InputLabelProps={{ shrink: true }}
                    value={data?.description}
                  />
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    label="status"
                    name="status"
                    value={data?.status === 1 ? "Active" : "Inactive"}
                  />
                </Grid>
              </Grid>
            </CardContent>}
            
          </CardLayout>
        </Box>
      </>
    </div>
  );
};

export default ViewBanner;
